export class StoreConvert{
    isSaved:string;
    rowCheck: boolean;
    jobberCustId:number;
    sapClntCd:string;
    sapJobberPayerNum:string;
    sapCustNum:string;
    sapCustShipToName:string;
    creationDate:string;
    ediTpId : string;
    sapJobberPayerNumOriginal:string;
    
    constructor(
        jobberCustId:number,
    sapClntCd:string,
    sapJobberPayerNum:string,
    sapCustNum:string,
    sapCustShipToName:string,
    sapJobberPayerNumOriginal:string
    ){
        this.jobberCustId = jobberCustId;
        this.sapClntCd =  sapClntCd;
        this.sapJobberPayerNum =  sapJobberPayerNum;
        this.sapCustNum =  sapCustNum;
        this.sapCustShipToName =  sapCustShipToName;
        this.sapJobberPayerNumOriginal=sapJobberPayerNumOriginal;
    }
}